import { render } from "./HoldersTable.vue?vue&type=template&id=51933b71&scoped=true"
import script from "./HoldersTable.vue?vue&type=script&lang=js"
export * from "./HoldersTable.vue?vue&type=script&lang=js"

import "./HoldersTable.vue?vue&type=style&index=0&id=51933b71&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51933b71"

export default script